import DefaultValidator from './default-validator';
import ActionValidator from './action-validator';
import {ACTIONS} from '../definitions/actions-methods';

/**
 * Class to validate resources
 *
 * // In this case the 'users' part
 * Auth.users.add
 * @extends DefaultValidator
 */
export default class ResourceValidator extends DefaultValidator {
    /**
     * Creates the proper validator based on instance state
     * @param {string} unknownProperty
     * @return {DefaultValidator}
     */
    $validate(unknownProperty) {
        if (!this.isAllowed) {
            // Override isAllowed to enable chain evaluation in ActionValidator
            return this.$addValidator(unknownProperty, ActionValidator, {isAllowed: true});
        }
        // Since it has Full Access rights no need to keep evaluating
        return this.$addValidator(unknownProperty, DefaultValidator);
    }

    /**
     * Checks if the Full Access permissions have been set
     * for this resource
     * @return {boolean} - True === Has Full Access rights
     */
    get isAllowed() {
        const actions = this.$permissions[this.$property];
        return !!actions && actions.includes(ACTIONS.all);
    }
}
